import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {ifCompletedInput, isTrue} from "../../../utils/other";
import {CurrencyFormatter, optionsTemplate, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import CheckBox from '../../form/CheckBox';

const sortable = true;
const filterable = true;

class ProductDataImporterForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-md-5">
                        <DateTimeInput
                            name="created_at"
                            label="Letöltés dátuma"
                            {...this.props.getFieldProps("created_at")}
                            value={this.props.values.created_at}
                            showTime={false}
                            disabled={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-5">
                        <TextInput
                            name="state"
                            value={this.props.values["state"]}
                            label="Állapot kódja"
                            disabled={true}
                            {...this.props.getFieldProps("state")}
                        />
                    </div>
                </div>
                <Fragment>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <SelectorGrid
                                {...this.props.getFieldProps("items")}
                                ref={(e) => this.items = e}
                                className={"p-small-table"}
                                view={["id", "name", "barcode", "sku", "listprice", "exists", "importable"]}
                                selectionMode="single"
                                columns={{
                                    "name": {
                                        header: 'Elnevezés/cím',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "barcode": {
                                        header: 'Vonalkód',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "sku": {
                                        header: 'ISBN',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "listprice": {
                                        header: 'Ár',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "exists": {
                                        header: 'Létezik',
                                        width: 1,
                                        className: "flagbox",
                                        sortable,
                                        filterable,
                                        renderer: (value, row, rowIndex, props, parent) => <CheckBox
                                            name="exists"
                                            checked={isTrue(value)}
                                            disabled={true}
                                            label={false}
                                        />
                                    },
                                    "importable": {
                                        header: 'Letölthető',
                                        width: 1,
                                        className: "flagbox",
                                        sortable,
                                        filterable,
                                        renderer: (value, row, rowIndex, props, parent) => <CheckBox
                                            name="importable"
                                            value={value}
                                            label={false}
                                            saveChanges={(field, value) => {
                                                parent.onEditorValueChange(props, isTrue(value), {ignoreEqual: true});
                                            }}
                                        />
                                    }
                                }}
                                name="items"
                                onItemUpdate={true}
                                itemActions={false}
                                data={this.props.values}
                                orderBy={{field: "name", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                </Fragment>
            </form>
        );
    }
}

export default createForm(ProductDataImporterForm);
